import React from 'react';
import Tags from './Tags';
import ImageOptimized from './ImageOptimized';
import VideoOptimized from './VideoOptimized';
import GifOptimized from './GifOptimized';
import ImageSlider from './ImageSlider';
import CloseButton from './CloseButton';
import './ProjectCase.css';

const ProjectCase = ({ project, onClose }) => {

    return (
        <div className="project-case">
            <div className="project-case__header">
                {project.tags && (
                    <Tags project={project} />
                )}
                <h3>{project.title}</h3>
            </div>
            <p dangerouslySetInnerHTML={{ __html: project.text1 }} />
            {project.imageSrc1 && (
                <ImageOptimized src={project.imageSrc1} alt={project.title+" 1"} />
            )}
            {project.slider1 && (
                <ImageSlider project={project} sliderKey="slider1" />
            )}
            {project.text2 && (
                <p>{project.text2}</p>
            )}
            {project.imageSrc2 && (
                <ImageOptimized src={project.imageSrc2} alt={project.title+" 2"} />
            )}
            {project.slider2 && (
                <ImageSlider project={project} sliderKey="slider2" />
            )}
            {project.text3 && (
                <p>{project.text3}</p>
            )}
            {project.imageSrc3 && (
                <ImageOptimized src={project.imageSrc3} alt={project.title+" 3"} />
            )}
            {project.text4 && (
                <p>{project.text4}</p>
            )}
            {project.imageSrc4 && (
                <ImageOptimized src={project.imageSrc4} alt={project.title+" 4"} />
            )}
            {project.imageSrc5 && (
                <ImageOptimized src={project.imageSrc5} alt={project.title+" 5"} />
            )}
            {project.text5 && (
                <p>{project.text5}</p>
            )}
            {project.imageSrc6 && (
                <ImageOptimized src={project.imageSrc6} alt={project.title+" 6"} />
            )}
            {project.imageSrc7 && (
                <ImageOptimized src={project.imageSrc7} alt={project.title+" 7"} />
            )}
            {project.imageSrc8 && (
                <ImageOptimized src={project.imageSrc8} alt={project.title+" 8"} />
            )}
            {project.gif && (
                <GifOptimized src={project.gif} alt={project.title+" gif"} />
            )}
            {project.videoSrc && (
                <VideoOptimized src={project.videoSrc} />
            )}
            {project.link && (
                <a href={project.link} target='_blank' rel="noreferrer noopener">
                    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.41826 0H10.4418C10.7501 0 11 0.249903 11 0.558174V5.58174C11 5.89001 10.7501 6.13992 10.4418 6.13992C10.1336 6.13992 9.88365 5.89001 9.88365 5.58174V1.90573L0.789378 11L0 10.2106L9.09427 1.11635H5.41826C5.10999 1.11635 4.86008 0.866445 4.86008 0.558174C4.86008 0.249903 5.10999 0 5.41826 0Z" fill="black" />
                    </svg>
                    {project.textLink}
                </a>
            )}
            <CloseButton onClose={onClose} />
        </div>
    );
};

export default ProjectCase;
